<div class="d-flex mb-2">
	<div class="flex-shrink-0">
		@if (imageSrc != null && imageSrc != undefined) {
			<img [src]="avatarImageUrl" alt="" class="avatar-xs rounded-circle shadow" />
		} @else {
			<img src="./assets/images/users/avatar.jpg" alt="" class="avatar-xs rounded-circle shadow" />
		}
	</div>
	<div class="flex-grow-1 ms-3">
		<h5 class="fs-14 mb-1">
			{{ userName }} <small class="fs-12 text-muted ms-2">{{ date }}</small>
		</h5>
		<p>{{ message }}</p>
	</div>
</div>
